'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

// Utils
import { combineClasses } from '@shared/utils';
import { getContentTooltipFromHrefNav } from '@/utils';

// Hooks
import { useScrollIntoView } from '@shared/hooks';

// Components
import { Tooltip } from '@shared/ui';

// Types
import { NavigationItemProps } from '@/types';

// Constants
import { PROJECT_TOOLTIP_CONTENT, EMPLOYEE_TOOLTIP_CONTENT } from '@/constants/tooltip';
export enum NavigationVariant {
  Employee = 'employee',
  Project = 'project',
}
interface CommonNavigationItemProps extends NavigationItemProps {
  variant: NavigationVariant;
  showActiveState?: boolean;
}
export const NavigationItem = ({
  href,
  icon,
  className,
  variant,
  showActiveState = false
}: CommonNavigationItemProps) => {
  const pathname = usePathname();
  const isActive = showActiveState && pathname.includes(href.replace('.', ''));
  const itemRef = useScrollIntoView<HTMLAnchorElement>(isActive);
  const contentTooltip = getContentTooltipFromHrefNav(href);
  return <div data-testid={`${variant}-nav-container`} className={combineClasses(className)} data-sentry-component="NavigationItem" data-sentry-source-file="index.tsx">
      <Link ref={itemRef} href={href} className={combineClasses('flex-center sm:flex-col gap-2 group outline-none', 'hover:bg-transparent cursor-pointer')} data-sentry-element="Link" data-sentry-source-file="index.tsx">
        <Tooltip className={combineClasses((contentTooltip === EMPLOYEE_TOOLTIP_CONTENT.ACTIVITIES || contentTooltip === PROJECT_TOOLTIP_CONTENT.ACTIVITIES) && 'left-auto right-0 -translate-x-0 xl:left-1/2 xl:-translate-x-1/2 [&_span]:left-auto [&_span]:right-1 [&_span]:-translate-x-1 [&_span]:xl:left-1/2 [&_span]:xl:-translate-x-1/2')} content={contentTooltip} data-sentry-element="Tooltip" data-sentry-source-file="index.tsx">
          <div className={combineClasses('flex-center', variant === NavigationVariant.Employee ? 'text-white' : 'text-primary-700')}>
            {icon}
          </div>
        </Tooltip>
      </Link>
    </div>;
};